import { createFileRoute } from "@tanstack/react-router";
import { Shell } from "@/components/control-tower/Layout";
import { AgentTeamPanel } from "@/components/building/dashboard/AgentTeamPanel";

export const Route = createFileRoute("/team")({
  component: TeamPage,
});

// Kiinteistötiimi — the Kairos agent team as a scope-aware Toiminto (action nav), not a
// perspective: the team is not a *lens on* the building, it is the system *working on* it. The
// whole roster is always-visible content at every inventory scope (kiinteistökanta / salkku /
// building) — AgentTeamPanel itself narrows each card's status and its detail panel to that
// scope, so this route never gates on "pick a building first".
function TeamPage() {
  return (
    <Shell
      title="Kiinteistötiimi"
      subtitle="Kairos-tiimi · agentit ja tuotokset"
    >
      <AgentTeamPanel />
    </Shell>
  );
}
